<template>
    <!-- 
    1.화면ID      : MCF_AM_002
    2.화면명      : 메일발신 이력
    3.작성자      : 김찬종 차장
    4.화면설명    : 메일발신 결과를 조회한다.
    5.Descrition : 2024.04.09 최초작성
    * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
    -->
        
          <div class="content-wrap">
            <div class="row">
              <!-- 검색 영역 시작 -->
              <div class="search-wrap">
                <div class="row">
                  <div class="col-md-2">
                    <div class="mb-3">
                      <ElLabel name="프로그램명">
                        <template v-slot:end="slotProps">
                          <ElInput :id="slotProps.id" v-model="state.searchParams.call_prgm_nm"  />
                        </template>
                      </ElLabel>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-3">
                      <ElLabel name="수신자">
                        <template v-slot:end="slotProps">
                          <ElInput :id="slotProps.id" v-model="state.searchParams.receiver_nm"  />
                        </template>
                      </ElLabel>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="mb-3">
                      <ElLabel name="제목">
                        <template v-slot:end="slotProps">
                          <ElInput :id="slotProps.id" v-model="state.searchParams.title"  />
                        </template>
                      </ElLabel>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <ElLabel name="등록일자"/>
                      <div class="d-flex">
                        <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.searchParams.fr_date = r" v-model="state.searchParams.fr_date"/> ~
                        <DatePicker :frmType="'YMD'" format="yyyy-MM-dd" @return="r => state.searchParams.to_date = r" v-model="state.searchParams.to_date"/> 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 검색 영역 종료 -->
              <div class="search-detail-wrap"></div>
              <div class="text-end py-2">
                <ElButton type="search" @buttonClick="onSearch()">검색</ElButton>
              </div>
              <!-- 그리드 영역 시작 -->
              <div class="table-responsive table-list">
                <DataTable
                    :value="state.gridRowData"
                    v-model:selection="state.selectRow" selectionMode="single" dataKey="eml_seq"
                    paginator :rows="20" :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
                    scrollable scrollHeight="400px"
                    stripedRows
                    @rowSelect="onRowSelect">
                    <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>
                    <Column field="row_no" header="NO" style="min-width:4rem;"></Column>
                    <Column field="call_prgm_id" header="프로그램ID" style="min-width:6rem"></Column>
                    <Column field="call_prgm_nm" header="프로그램명" style="max-width:8rem; text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"></Column>
                    <Column field="title" header="제목" style="max-width:30rem; text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"></Column>
                    <Column field="sender_id" header="발신자ID" style="min-width:5rem"></Column>
                    <Column field="sender_nm" header="발신자명" style="min-width:5rem"></Column>
                    <Column field="receiver_nms" header="수신자" style="max-width:8rem; text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"></Column>
                    <Column field="reg_dt" header="등록일자" style="min-width:8rem"></Column>
                </DataTable>
              </div>
              <!-- 그리드 영역 종료 -->
              <div class="text-end py-2">
  
              </div>


      <div class="modal fade" id="emailModal" tabindex="-1" aria-labelledby="emailModalLabel" aria-hidden="false">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-6" id="emailModalLabel">메일발신 상세</h1>
              <ElButton type="modelHeaderClose"></ElButton>
            </div>
            <div class="modal-body">
              <div class="register-wrap">

                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <ElLabel name="프로그램ID">
                        <template #end="{id}">
                          <ElInput :id="id" v-model="email.call_prgm_id" disabled = "true" />
                        </template>
                      </ElLabel>

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <ElLabel name="프로그램명">
                        <template #end="{id}">
                          <ElInput :id="id" v-model="email.call_prgm_nm" disabled = "true" />
                        </template>
                      </ElLabel>

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <ElLabel name="메일ID">
                        <template #end="{id}">
                          <ElInput :id="id" v-model="email.eml_seq" disabled = "true" />
                        </template>
                      </ElLabel>


                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <ElLabel name="발신자ID">
                        <template #end="{id}">
                          <ElInput :id="id" v-model="email.sender_id" disabled = "true" />
                        </template>
                      </ElLabel>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <ElLabel name="발신자명">
                        <template #end="{id}">
                          <ElInput :id="id" v-model="email.sender_nm" disabled = "true" />
                        </template>
                      </ElLabel>

                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <ElLabel name="등록일자">
                        <template #end="{id}">
                          <ElInput :id="id" v-model="email.reg_dt" disabled = "true" />
                        </template>
                      </ElLabel>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <ElLabel name="제목">
                        <template #end="{id}">
                          <ElInput :id="id" v-model="email.title" disabled = "true" />
                        </template>
                      </ElLabel>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <ElLabel name="내용">
                        <template #end="{id}">
                          <ElTextarea v-model="email.content"  rows="10" disabled/>
                        </template>
                      </ElLabel>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive table-list">
                <DataTable
                    :value="state.gridReceiverData"
                    scrollable scrollHeight="180px"
                    stripedRows>
                    <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>
                    <Column field="row_no" header="NO" style="min-width:4rem;"></Column>
                    <Column field="receiver_id" header="수신자ID" style="min-width:6rem"></Column>
                    <Column field="receiver_nm" header="수신자명" style="min-width:6rem"></Column>
                    <Column field="receiver_email" header="메일주소" style="min-width:12rem"></Column>
                    <Column field="success_yn" header="성공여부" style="min-width:5rem"></Column>
                    <Column field="upd_dt" header="발신일시" style="min-width:12rem"></Column>
                </DataTable>
              </div>
            </div>
            <div class="modal-footer">
              <ElButton type="modelFooterClose"@buttonClick="closeModal()">닫기</ElButton>
            </div>
          </div>
        </div>
      </div>


      </div>
    </div>
    <ElInput v-show="false" data-bs-toggle="modal" data-bs-target="#emailModal" ref="emailModalRef"/>
  </template>

<script setup>   
    import {reactive,ref,onBeforeMount,onMounted,computed} from 'vue';
    import DatePicker     from '@/components/common/DatePicker';
    import common         from '@/js/common';
    import DataTable      from 'primevue/datatable';
    import Column         from 'primevue/column';
  
    import { useLoading } from '@/composable/Loading.js'
    const { setIsLoading } = useLoading()
    import { sendList } from '@/api/email';
    import { receiveList } from '@/api/email';

    const email = ref({});
    const emailModalRef = ref();

    /** 검색기간 초기화 */
    const today = new Date();
    const frday = common.addMonth(today, -1);

    const frDate = common.dateFormat(frday);
    const toDate = common.dateFormat(today);

    onBeforeMount(() => {
  
    });
  
    onMounted(async () => {
      state.searchParams.fr_date = frDate;
      state.searchParams.to_date = toDate;
      await onSearch();
    });
  
    //변수 선언 영역 
    const state = reactive({
        gridRowData :[],
        selectRow : null,
        searchParams : {
            call_prgm_nm  : '',
            receiver_nm   : '',
            title         : '',
            fr_date       : '',
            to_date       : '',
            page_count    : 1,
            unit_count    : 100000
        },
        gridReceiverData :[]
    });
  
    const onSearch = async () => {
      try {
        setIsLoading(true)
        const res = await sendList(state.searchParams)
        state.gridRowData = res.rtn;
      } catch (err) {
        alert("전송 중 에러가 발생하였습니다.");
      } finally {
        setIsLoading(false)
      }
    };

    const getReceiverList = async (emlSeq) => {
      const params = { eml_seq: emlSeq };
      try {
        setIsLoading(true)
        const res = await receiveList(params)
        state.gridReceiverData = {};
        state.gridReceiverData = res.rtn;
      } catch (err) {
        alert("전송 중 에러가 발생하였습니다.");
      } finally {
        setIsLoading(false)
      }
    }
    
    const onRowSelect = async (event) => {
      if(event.type == 'row') {
        email.value = {...event.data};
        emailModalRef.value.input.click();
        await getReceiverList(email.value.eml_seq);
      }
    };

    const closeModal = () => {
      emailModalRef.value.input.click();
      email.value = {};
      state.gridReceiverData = {};
    };

  </script>
  